import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import style from './Logo.module.scss'
/* import LogoSrc from '../../../static/assets/images/ashmanov-net-logo-small.svg' */
import I18nLink from '../../i18n/Link'
import AshmanovLogo from './AshmanovLogo'

class Logo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: props.intl.messages.logo,
    }
  }

  static propTypes = {
    intl: PropTypes.object,
    className: PropTypes.string,
  }
  render() {
    const addClass = this.props.className
    const { data } = this.state
    return (
      <I18nLink to="/">
        <div className={classnames(style.logo, addClass)}>
          {/* <img src={LogoSrc} /> */}
          <AshmanovLogo />
          <p
            className={style.containerP}
            dangerouslySetInnerHTML={{ __html: data.text }}
          />
        </div>
      </I18nLink>
    )
  }
}

export default injectIntl(Logo)
